export const availableRequirementValidators = {
    HAS_UPPER_LETTER: 'hasUpperLetter',
    HAS_LOWER_LETTER: 'hasLowerLetter',
    HAS_NUMBERS: 'hasNumbers',
    HAS_MINIMUM_LENGTH: 'hasMinimumLength',
};
